import {
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    useQuery,
} from "react-query";

import { IExternalListPage } from "../../types";
import { AmazonEtd, IAmazonEtdResult } from "../../utils/api";
import { useAuth } from "../useAuth";

type TUseQueryOptions<
    TQueryFnData,
    TError,
    TData,
    TQueryKey extends QueryKey,
> = Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, "queryFn">;

export interface IUseGetAmazonEtdResultsParameters {
    cursor?: string;
    direction?: string;
    limit: number;
    asin?: string;
    pincode?: string;
    startDate?: string;
    endDate?: string;
    options?: TUseQueryOptions<
        any,
        unknown,
        IExternalListPage<IAmazonEtdResult>,
        string[]
    >;
}

export const useGetAmazonEtdResults = (
    parameters: IUseGetAmazonEtdResultsParameters,
): UseQueryResult<IExternalListPage<IAmazonEtdResult>, unknown> => {
    const {
        options,
        cursor,
        direction,
        limit,
        asin,
        pincode,
        startDate,
        endDate,
    } = parameters;

    const { token } = useAuth();

    if (!token) {
        throw new Error(
            "Cannot fetch Amazon ETD results without authentication token",
        );
    }
    return useQuery({
        queryKey: options?.queryKey ?? [],
        queryFn: async () => {
            const response = await AmazonEtd.getResults({
                direction,
                limit,
                cursor,
                asin,
                pincode,
                startDate,
                endDate,
                token,
            });

            return response;
        },
        ...options,
    });
};
